import { inject, injectable } from "inversify";
import HttpService from "./http.service";
import IdentityService from "./identity.service";
import ToastService from "./toast.service";
import { PaymentType } from "../typings";
import { PaymentService as paymentService} from "./openapi/generated";

@injectable()
export default class PaymentService {
    @inject(HttpService)
    public httpService: HttpService;

    @inject(IdentityService)
    public identity: IdentityService;

    @inject(ToastService)
    public toastService: ToastService;

    public interval: any;
    public completed: boolean;
    public error: boolean;

    public async initiatePayment(type: PaymentType, amount: number): Promise<{id: number, orderId?: string, meta?: any, invoiceId?: string}> {
        return paymentService.paymentControllerRegisterPayment({
            amount,
            type,
        });
    }

    public polPaymentStatus(id: number, onCompleted: () => void, onError: () => void): void {
        this.interval = setInterval(() => this.checkPaymentStatus(id,() => onCompleted(), () => onError()), 5000);
    }

    public reset(): void {
        if(this.completed || this.error) {
            this.completed = false;
            this.error = false;
            clearInterval(this.interval);
        }
    }

    private async checkPaymentStatus(id: number, onCompleted: () => void, onError: () => void): Promise<void> {
        const res = await paymentService.paymentControllerCheckStatus(id);
        if (res) {
            if (res.paymentStatus === "completed") {
                this.completed = true;
                onCompleted();
                clearInterval(this.interval);
                // Show notification?
            } else if (res.paymentStatus === "rejected") {
                this.error = true;
                onCompleted();
                clearInterval(this.interval);
            }
        } else if (this.interval == null) {
            this.polPaymentStatus(id, () => onCompleted(), () => onError());
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/payment.service.ts